// extracted by mini-css-extract-plugin
export default {"commentForm":"FeedCommentInput_commentForm__VTuoi","commentInput":"FeedCommentInput_commentInput__9TyhR","submitButton":"FeedCommentInput_submitButton__+B9qi"};